import React from "react";
import { useTranslation } from "react-i18next";

const CookiesPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto p-6 mt-16 mb-10 
                    bg-white dark:bg-background-dark 
                    text-gray-800 dark:text-text-dark 
                    text-sm leading-relaxed 
                    rounded-xl shadow-md">
      <h1 className="text-2xl font-bold mb-6 
                     text-black dark:text-white">
        {t("cookie.learn_more")}
      </h1>

      <p className="mb-4">{t("cookie_policy.intro")}</p>

      <h2 className="text-lg font-semibold mt-6 mb-2 
                     text-black dark:text-white">
        {t("cookie_policy.types_title")}
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>{t("cookie_policy.essential")}</li>
        <li>{t("cookie_policy.analytics")}</li>
        <li>{t("cookie_policy.marketing")}</li>
      </ul>

      <h2 className="text-lg font-semibold mt-6 mb-2 
                     text-black dark:text-white">
        {t("cookie_policy.legal_title")}
      </h2>
      <p className="mb-4">{t("cookie_policy.legal_text")}</p>

      <h2 className="text-lg font-semibold mt-6 mb-2 
                     text-black dark:text-white">
        {t("cookie_policy.manage_title")}
      </h2>
      <p>{t("cookie_policy.manage_text")}</p>

      <h2 className="text-lg font-semibold mt-6 mb-2 
                     text-black dark:text-white">
        {t("cookie_policy.contact_title")}
      </h2>
      <p>
        {t("cookie_policy.contact_text")}{" "}
        <a
          href="mailto:privacy@modularobjects.com"
          className="text-primary-light dark:text-primary-dark hover:underline"
        >
          privacy@modularobjects.com
        </a>.
      </p>
    </div>
  );
};

export default CookiesPolicy;
